import { render, staticRenderFns } from "./registration-container.vue?vue&type=template&id=04f4b65a"
import script from "./registration-container.vue?vue&type=script&lang=js"
export * from "./registration-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports